import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import {PlainBackLink} from '../../styledComponents/Links'
import {DisplayItemDividerForPageTop, DisplayItemTitle} from '../../styledComponents/DisplayItem'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {BlockSpacer} from '../../styledComponents/ResponsiveConvenience'
import {ApplyButton, PcMarginLeft30, WhiteArea} from './AccountTransferCommon'
import {LOGIN_MODE, MESSAGE_TYPE, RECEIVING_AGENCY_CD, RESIDENT_USER_TYPE} from '../../CodeMaster'
import {
    FlexGrowContent,
    FullWidthColumnFlexContainer,
    LeftRowFlexContainer,
} from '../../styledComponents/FlexComponents'
import {OpenInNew} from '@mui/icons-material'
import {Box} from '@mui/material'
import {ResidentAccountTransferContactUs} from './AccountTransferContactUs'
import NatTokenRepo from '../../__NoAutomatedTests/components/token/repository/NatTokenRepo'
import {NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {
    ResidentLoginInfoSessionStorageKey,
} from '../../__NoAutomatedTests/common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentMessageDialogComponent
    from '../../__NoAutomatedTests/components/common/resident/NatResidentMessageDialogComponent';
import {Messages} from '../../Messages';

interface Props {
    tokenRepo: NatTokenRepo
    condominiumCd: string
    eventEmitter: EventEmitterExResident
}

interface State {
    token: string
    policyCheckd: boolean
    isLoadCompleted: boolean
    isSubUser: boolean
    isAdminUser: boolean
    openDialog: boolean
}

class ResidentAccountTransferPrivacyPolicyToSmbcPage extends Component<Props & ResidentPagePropsSet, State> {

    privatePolicy: string

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        const userType = SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_USER_RESIDENT_USER_TYPE)
        const isSubUser = userType === RESIDENT_USER_TYPE.SUB.value
        const isAdminUser = SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.ADMIN.value

        this.handleDialogOkClick = this.handleDialogOkClick.bind(this)
        this.handleApplyButtonClick = this.handleApplyButtonClick.bind(this)

        this.state = {
            token: '',
            policyCheckd: false,
            isLoadCompleted: false,
            isSubUser: isSubUser,
            isAdminUser: isAdminUser,
            openDialog: false,
        }

        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)

        this.privatePolicy =
            '<ol style="padding-inline-start: 15px;">' +
            '<li><p>口座振替手続きの際にご提供いただいた個人情報につきましては、当社受託マンションにおいて管理費等の収納及び' +
            '督促に関する業務をはじめとした、マンション管理に関する業務を適正に運営する上で利用させて頂き、責任を持って管理致します。</p></li>' +
            '<li><p>口座振替手続きの際にご提供いただいた個人情報につきましては、当社のマンション管理に関する業務のため、' +
            '個人情報を適切に管理することを義務付けた委託先へ、委託することがございます。</p></li>' +
            '<li><p>入力をいただいた個人情報（データ）に関して、利用目的の通知及び開示のご請求、訂正・削除または消去・' +
            '利用の停止を希望される場合は、下記の個人情報問い合わせ先まで、ご連絡下さい。</p></li>' +
            '<li><p>個人情報の入力（提供）は任意でございますが、個人情報のご提供がいただけない場合には、' +
            '管理費等の収納及び督促に関する業務が、一部実施出来ない場合がありますので、予めご了承下さい。</p></li>' +
            '<li><p>個人情報保護管理者</p></li>' +
            '<p>〔東京地区〕</p>' +
            '<p>　　(株)長谷工コミュニティ　常務執行役員　笠原 徹</p>' +
            '<p>　　TEL：03-3457-1217　FAX：03-3457-1004</p>' +
            '<p>〔関西地区〕</p>' +
            '<p>　　(株)長谷工コミュニティ　取締役兼常務執行役員　永平 貴嗣</p>' +
            '<p>　　TEL：06-6201-5165　FAX：06-6201-5092</p>' +
            '</ol>' +
            '<p>当社個人情報保護方針につきましては、' +
            '<a href="https://www.haseko-hcm.co.jp/privacy/" target="_blank">こちら</a>をご覧ください。</p>'
    }

    async componentDidMount(): Promise<void> {
        const {eventEmitter} = this.props
        const {isSubUser} = this.state

        await eventEmitter.showLoading()
        try {
            if (!isSubUser) {
                await this.setupToken()
            }
            this.setState({
                isLoadCompleted: true,
            })
        } catch {
            return
        } finally {
            eventEmitter.closeLoading()
        }
    }

    async setupToken(): Promise<void> {
        const {tokenRepo, navigate} = this.props

        const tokenResponse = await NatAsyncCallFunction(
            tokenRepo.getTokenAccountTransfer.bind(tokenRepo),
            navigate,
        )
        if (!tokenResponse) {
            throw Error('通信エラー')
        }
        this.setState({
            token: tokenResponse.details,
        })
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({policyCheckd: event.target.checked})
    }

    handleDialogOkClick(): void {
        this.setState({openDialog: false})
    }

    handleApplyButtonClick(event: any): void {
        if(this.state.isAdminUser) {
            event.preventDefault()
            this.setState({openDialog: true})
        }
    }

    render(): ReactNode {
        const {condominiumCd} = this.props
        const {token, isLoadCompleted} = this.state

        if (!isLoadCompleted) {
            return null
        }

        return <>
            <NatResidentMessageDialogComponent
                open={this.state.openDialog}
                params={{
                    title: '確認',
                    errorLevel: MESSAGE_TYPE.INFORMATION,
                    message: Messages.ISYCR0001.toString(),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleDialogOkClick,
                        },
                    ],
                }}
            />
            <PlainBackLink
                to={`/resident/condominiums/${this.props.condominiumCd}/applications/account-transfer/${RECEIVING_AGENCY_CD.SMBC_CARD.value}`}>
                戻る
            </PlainBackLink>
            <BlockSpacer height={'16px'}/>
            <DisplayItemDividerForPageTop/>
            <BlockSpacer height={'10px'}/>
            <WhiteArea>
                <DisplayItemTitle>個人情報保護方針への同意</DisplayItemTitle>
                <PcMarginLeft30>
                    <BlockSpacer height={'26px'}/>
                    <div>個人情報の取扱いに同意の上、口座情報の入力に進んでください。</div>
                    <BlockSpacer height={'20px'}/>
                    <PolicyArea>
                        <PolicyTitle>個人情報の取扱いについて</PolicyTitle>
                        <PolicyHtml dangerouslySetInnerHTML=
                                        {{__html: this.privatePolicy}}/>
                    </PolicyArea>
                </PcMarginLeft30>
                <BlockSpacer height={'20px'}/>
                <FullWidthColumnFlexContainer>
                    <PolicyCheckBoxStyled>
                        <LeftRowFlexContainer>
                            <input
                                type="checkbox"
                                checked={this.state.policyCheckd}
                                disabled={this.state.isSubUser}
                                onChange={this.onChangePolicyChecked}
                            />
                            <BlockSpacer width={'13px'}/>
                            個人情報の取扱いについて同意する
                        </LeftRowFlexContainer>
                    </PolicyCheckBoxStyled>
                </FullWidthColumnFlexContainer>
                <ApplyButton
                    disabled={!this.state.policyCheckd}
                    to={`/account-transfer/${RECEIVING_AGENCY_CD.SMBC_CARD.value}/registration/request?token=${token}`}
                    target={'_blank'}
                    onClick={this.handleApplyButtonClick}>
                    <FlexGrowContent>
                        <OpenInNew fontSize={'large'}/>
                    </FlexGrowContent>
                    <div>
                        口座情報の入力に進む
                        <Box fontWeight={FontWeights.Normal} fontSize={FontSize.Small} marginTop={'3px'}>
                            (外部サイトが新しい画面で開きます)
                        </Box>
                    </div>
                    <FlexGrowContent/>
                </ApplyButton>

            </WhiteArea>
            <Box height={'20px'}/>
            <ResidentAccountTransferContactUs/>
        </>
    }
}

export default createResidentPage(ResidentAccountTransferPrivacyPolicyToSmbcPage)

const PolicyArea = styled.div`
  background-color: ${Colors.Surface};
  padding: 10px 15px;
  box-sizing: border-box;
  word-break: normal;
  line-break: strict;
  border: 1px solid #D9D9D9;
`
const PolicyTitle = styled.div`
  font-size: ${FontSize.Body};
  font-weight: bold;
`
const PolicyHtml = styled.div`
  font-size: ${FontSize.Small};
`
const PolicyCheckBoxStyled = styled.label`
  font-size: ${FontSize.Body};
`
